// extracted by mini-css-extract-plugin
export default {"root":"MuYurF_kRjrcaMvENcL_","App":"M0KloWeIi0S2uoD0WX4W"};